module.exports = __webpack_public_path__ + "static/media/green-check.89556da2.svg";